export enum AmountFilterOption {
  BUDGET = "BUDGET",
  VALUE = "VALUE",
}
